import React, { useState } from 'react';
import { Link, useLocation } from 'react-router-dom';

function NavBar() {
  const [isMenuOpen, setIsMenuOpen] = useState(false);
  const location = useLocation();

  const isActive = (path) => {
    if (path === '/') return location.pathname === '/';
    return location.pathname.startsWith(path);
  };

  const navLinkClass = (path) =>
    `font-medium transition-colors duration-200 ${
      isActive(path) ? 'text-blue-400' : 'text-neutral-300 hover:text-white'
    }`;

  return (
    <header className="sticky top-0 z-50 w-full border-b border-neutral-800 bg-neutral-950/95 backdrop-blur-md">
      <div className="page-container flex h-16 items-center justify-between">
        <Link to="/" className="text-xl font-bold tracking-tight text-white">
          Fitness
        </Link>
        <nav className="hidden min-[980px]:block">
          <ul className="flex items-center gap-8">
            <li>
              <Link to="/" className={navLinkClass('/')}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/Workouts" className={navLinkClass('/Workouts')}>
                Workouts
              </Link>
            </li>
            <li>
              <Link to="/Nutrition" className={navLinkClass('/Nutrition')}>
                Nutrition
              </Link>
            </li>
          </ul>
        </nav>
        <button
          type="button"
          onClick={() => setIsMenuOpen(!isMenuOpen)}
          className="min-[980px]:hidden rounded-lg p-2 text-neutral-300 hover:bg-neutral-800 hover:text-white focus:outline-none focus:ring-2 focus:ring-blue-500/50"
          aria-label="Toggle menu"
        >
          <svg className="h-6 w-6" fill="none" stroke="currentColor" viewBox="0 0 24 24">
            {isMenuOpen ? (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M6 18L18 6M6 6l12 12" />
            ) : (
              <path strokeLinecap="round" strokeLinejoin="round" strokeWidth={2} d="M4 6h16M4 12h16M4 18h16" />
            )}
          </svg>
        </button>
      </div>
      {isMenuOpen && (
        <div className="min-[980px]:hidden border-t border-neutral-800 bg-neutral-900/98 px-4 py-4 backdrop-blur-md">
          <ul className="flex flex-col gap-1">
            <li>
              <Link to="/" onClick={() => setIsMenuOpen(false)} className={`block rounded-lg px-4 py-3 text-sm font-medium ${navLinkClass('/')} ${isActive('/') ? 'bg-neutral-800' : 'hover:bg-neutral-800'}`}>
                Home
              </Link>
            </li>
            <li>
              <Link to="/Workouts" onClick={() => setIsMenuOpen(false)} className={`block rounded-lg px-4 py-3 text-sm font-medium ${navLinkClass('/Workouts')} ${isActive('/Workouts') ? 'bg-neutral-800' : 'hover:bg-neutral-800'}`}>
                Workouts
              </Link>
            </li>
            <li>
              <Link to="/Nutrition" onClick={() => setIsMenuOpen(false)} className={`block rounded-lg px-4 py-3 text-sm font-medium ${navLinkClass('/Nutrition')} ${isActive('/Nutrition') ? 'bg-neutral-800' : 'hover:bg-neutral-800'}`}>
                Nutrition
              </Link>
            </li>
          </ul>
        </div>
      )}
    </header>
  );
}

export default NavBar;